// Action Constants

export enum ActionConstant {
	GET_PLAN_LIST = 'FILE://SUBSCRIPTION_PLAN_MANAGEMENT/GET_PLAN_LIST',
	GET_PLAN_DETAILS = 'FILE://SUBSCRIPTION_PLAN_MANAGEMENT/GET_PLAN_DETAILS',
	GET_STATUS = 'FILE://SUBSCRIPTION_PLAN_MANAGEMENT/GET_STATUS',
	CLEAR_DETAILS = 'FILE://SUBSCRIPTION_PLAN_MANAGEMENT/CLEAR_DETAILS',
	CLEAR_PLAN_DETAILS = 'FILE://SUBSCRIPTION_PLAN_MANAGEMENT/CLEAR_PLAN_DETAILS',
	CLEAR_STATUS = 'FILE://SUBSCRIPTION_PLAN_MANAGEMENT/CLEAR_STATUS',
	GET_PLAN_LIST_FAILED = 'FILE://SUBSCRIPTION_PLAN_MANAGEMENT/GET_PLAN_LIST_FAILED',
	GET_PLAN_DETAILS_FAILED = 'FILE://SUBSCRIPTION_PLAN_MANAGEMENT/GET_PLAN_DETAILS_FAILED',
}

// State Types

// Action Types
export interface Lists {
	type: ActionConstant.GET_PLAN_LIST;
	count: number;
	rows: [];
}
export interface Plan {
	id: number;
	name: string;
	description: string;
	documentCount: number;
	documentSize: number;
	scanCount: number;
	projectCount: number;
	tradeCount: number;
	userCount: number;
	duration: number;
	durationUnit: number;
	amount: number;
	order: number;
}
export interface GetPlanType {
	type: ActionConstant.GET_PLAN_DETAILS;
	data: Plan;
}
export interface GetListType {
	type: ActionConstant.GET_PLAN_LIST;
	data: Lists;
}

export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}

export interface ClearListType {
	type: ActionConstant.CLEAR_DETAILS;
}
export interface ClearPlanType {
	type: ActionConstant.CLEAR_PLAN_DETAILS;
}
export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}
export interface GetPlanListFailedType {
	type: ActionConstant.GET_PLAN_LIST_FAILED;
}
export interface GetPlanDetailsFailedType {
	type: ActionConstant.GET_PLAN_DETAILS_FAILED;
}

export type ActionType =
	| GetListType
	| GetStatusType
	| ClearListType
	| ClearStatusType
	| GetPlanType
	| ClearPlanType
	| GetPlanListFailedType
	| GetPlanDetailsFailedType;

export interface InitialState {
	listFetching: boolean;
	list: [];
	statusCode: number;
	count: number;
	planlist: Plan[];
	plan: any;
	detailsFetching: boolean;
}
